<template>
  <div class="form-designer-component" v-if="isLoggedIn()">
    <input
      type="hidden"
      id="applicationId"
      :value="applicationId"
    />
    <input type="hidden" id="formId" :value="formId" />
    <input type="hidden" id="templateId" :value="templateId" />
    <input type="hidden" id="formName" :value="applicationForm.name" />
    <input type="hidden" id="isFormTemplate" :value="isFormTemplate" />
    <input type="hidden" :value="timeout" id="sessionIdleTimeOut" />
    <a
      class="d-none"
      id="formDesignerHelp"
      :href="baseHelpUrl + 'form_designer%2Fbpm_form_designer.htm'"
      target="_abpmPageHelp"
    >
    </a>
    <input
      type="hidden"
      :value="SERVLET_CONTEXT_PATH"
      id="servletContextPath"
    />
    <app-root></app-root>

    <div class="mcc-dialog-overlay">
      <dialog id="importFromFormDialog" class="mcc-dialog mcc-dialog--primary mcc-dialog--xs importForm">
        <section>
          <form @submit.prevent="handleImportFromForm()">
            <div class="mcc-dialog__header">
              <h2 class="h4">Choose a form</h2>
              <button class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDialog('importFromFormDialog')">
                                <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Button</span>
                            </button>
            </div>
            <div class="mcc-dialog__body importForm">
              <fieldset>
                <label for="selectFormImportCmp">Form</label>
                  <select id="selectFormImportCmp" name="selectFormImportCmp">
                  </select>
              </fieldset>
            </div>
            <div class="mcc-dialog__footer">
              <div class="mcc-button-group mcc-button-group--spaced">
                <button
                  type="button"
                  class="mcc-button mcc-button--outline"
                  @click="closeDialog('importFromFormDialog')"
                >
                  Close
                </button>
                <button type="submit" class="mcc-button mcc-button--primary">
                  Save
                </button>
              </div>
            </div>
          </form>
        </section>
      </dialog>
    </div>


    <div class="mcc-dialog-overlay">
      <dialog id="selectTemplateDialog" class="mcc-dialog mcc-dialog--primary mcc-dialog--xs importForm">
        <section>
          <form @submit.prevent="setSelectedForm()">
            <div class="mcc-dialog__header">
              <h2 class="h4">Choose a template</h2>
              <button class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDialog('selectTemplateDialog')">
                                <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Button</span>
                            </button>
            </div>
            <div class="mcc-dialog__body importForm">
              <input type="hidden" id="appendFormTemplate" />
              <fieldset>
                <label for="selectTemplateCmp">Template</label>
                  <select id="selectTemplateCmp" name="selectTemplateCmp">
                  </select>
              </fieldset>
            </div>
            <div class="mcc-dialog__footer">
              <div class="mcc-button-group mcc-button-group--spaced">
                <button
                  type="button"
                  class="mcc-button mcc-button--outline"
                  @click="closeDialog('selectTemplateDialog')"
                >
                  Close
                </button>
                <button type="submit" class="mcc-button mcc-button--primary">
                  Save
                </button>
              </div>
            </div>
          </form>
        </section>
      </dialog>
    </div>

    <div class="mcc-dialog-overlay">
      <dialog
        id="autoSaveConfigDialog"
        class="mcc-dialog mcc-dialog--primary mcc-dialog--xs"
      >
        <section>
          <form
            id="autoSaveForm"
            novalidate
            @submit.prevent="saveAutoSaveConfigurations()"
          >
            <div class="mcc-dialog__header">
              <h2 class="h4">Auto save</h2>
              <button class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDialog('autoSaveConfigDialog')">
                                <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Button</span>
                            </button>
            </div>
            <div class="mcc-dialog__body">
              <fieldset style="width: 400px">
                <div class="mfc-checkbox-wrapper mu-my-01">
                  <input
                    id="autoSaveFormDesigner"
                    class="mfc-switch"
                    name="autoSaveFormDesigner"
                    type="checkbox"
                    @change="handleAutoSaveChange"
                  />
                  <label for="checkboxInput18">Auto save</label>
                </div>
                <div class="mfc-input-wrapper">
                  <label for="interval">Interval</label>
                  <input
                    id="interval"
                    name="interval"
                    type="number"
                    max="1760"
                    min="60"
                    @change="handleIntervalChange($event)"
                    required
                  />
                  <div class="mfc-help-text">
                    Interval value is in seconds and max value:1760, min
                    value:60
                  </div>
                  <div class="mfc-invalid-feedback"></div>
                </div>
              </fieldset>
            </div>
            <div class="mcc-dialog__footer">
              <div class="mcc-button-group mcc-button-group--spaced">
                <button
                  type="button"
                  class="mcc-button mcc-button--outline"
                  @click="closeDialog('autoSaveConfigDialog')"
                >
                  Close
                </button>
                <button type="submit" class="mcc-button mcc-button--primary">
                  Save
                </button>
              </div>
            </div>
          </form>
        </section>
      </dialog>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import ApplicationFormAPI from "../services/ApplicationFormAPI";
import { EventBus } from "../services/event-bus";
import constantMessages from "../messages";
import constants from "../constants";

export default {
  name: "FormDesigner",
  data() {
    return {
      CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
      fetchCall: false,
      applicationId: this.$route.params.applicationId,
      formId: this.$route.params.formId,
      templateId: this.$route.params.formTemplateId,
      isFormTemplate: this.$route.params.formTemplateId ? true : false,
      applicationForm: {},
      baseHelpUrl: "",
      SERVLET_CONTEXT_PATH: constants.BASE_URL,
      timeout: "",
      designerInfo: null,
      designerVersion: process.env.VUE_APP_FORMDESIGNER_VERSION
    };
  },
  methods: {
    handleIntervalChange(e) {
      $(e.target)[0].checkValidity();
    },
    handleAutoSaveChange() {
      window.handleAutoSaveChange();
    },
    saveAutoSaveConfigurations() {
      let self = this;
      let interval =
        $("#interval").val() != ""
          ? parseInt($("#interval").val())
          : $("#interval").val();
      let data = {
        autoSaveFormDesigner: $("#autoSaveFormDesigner").prop("checked"),
        interval
      };
      if (this.validateAutoSaveData(data)) {
        ApplicationFormAPI.saveAutoSaveConfigurations(
          data.autoSaveFormDesigner,
          data.interval
        ).then(responseData => {
          window.setAutoSaveInternal(interval);
          window.resetAutoSave();
          if (responseData !== undefined) {
            window.popToast(
              constantMessages.MESSAGES[responseData.message],
              "success",
              "white",
              "ok"
            );
          }
        });
        self.closeDialog("autoSaveConfigDialog");
      }
    },
    validateAutoSaveData(data) {
      var isValid = true;
      var maxVal = parseInt($("#sessionIdleTimeOut").val() - 10);
      let form = $("#autoSaveForm")[0];
      if (!form.checkValidity()) {
        isValid = false;
      }
      form.classList.add("ms-was-validated");
      if (
        data.autoSaveFormDesigner &&
        (!data.interval || data.interval < 60 || data.interval > maxVal)
      ) {
        isValid = false;
      }
      return isValid;
    },
    setSelectedForm() {
      let self = this;
      let selectedTemplate = $("#selectTemplateCmp").val();
      if (selectedTemplate != "") {
        ApplicationFormAPI.getTemplateFormForImport(selectedTemplate).then(
          responseData => {
            window.formDesignHasChanged = false;
            if ($("#appendFormTemplate").val() === "true") {
              window.formDesignerAppComponent.zone.run(function() {
                window.formDesignerAppComponent.appendJsonToSelectedModel(
                  responseData.data.templateData
                );
              });
            } else {
              self.loadForm(responseData.data.templateData, true);
            }
            window.formDesignHasChanged = true;
          }
        );
      }
      this.closeDialog("selectTemplateDialog");
    },
    handleImportFromForm() {
      let selectedForm = $("#selectFormImportCmp").val();
      if (selectedForm != "") {
        ApplicationFormAPI.getFormForImport(selectedForm).then(responseData => {
          let formData = JSON.parse(responseData.data);
          window.formDesignerAppComponent.zone.run(function() {
            window.formDesignerAppComponent.importFormFn(formData);
            window.formDesignHasChanged = true;
          });
        });
      }
      this.closeDialog("importFromFormDialog");
    },
    closeDialog(id) {
      $(`#${id}`)
        .parent()
        .removeClass("mu-visible");
      $(`#${id}`)[0].close();
    },
    isLoggedIn() {
      return this.$store.getters.getIsUserLogin;
    },
    setDesignerInfo() {
      return new Promise((resolve, reject) => {
        let self = this;
        window.formDesignerAppComponent.zone.run(function() {
          window.formDesignerAppComponent.setDesignerVersion(self.designerVersion);
          window.formDesignerAppComponent.setIntegratedVersionFn(true);
          window.formDesignerAppComponent.setIsTemplate(self.isFormTemplate);
          window.getFormHistoryData();
          window.formDesignerAppComponent.fetchThemeDataFn();
        });
        resolve();
      })
    },
    async loadForm(formDataInput, changed) {
      try {
        await this.designerInfo;
        let self = this;
        let formData = JSON.parse(formDataInput);
        if(window.formDesignerAppComponent) {
            setTimeout(() => {
              window.formDesignerAppComponent.zone.run(function() {
                window.formDesignerAppComponent.setTitleFn(self.applicationForm.name);
                window.formDesignerAppComponent.importFormFn(formData);
                window.formDesignHasChanged = changed;
              });
            }, 0);
        } else {
          new Promise(r => setTimeout(r, 1000)).then(() => {
          self.loadForm(formDataInput, changed)
          });
        }
      } catch(error) {
        console.log(error);
        EventBus.$emit("error-notification", {
          msg: "Error while loading form designer scripts"
        });
      }
    },
    loadScript(filename, options = {}) {
      let baseUrl = "";
      // Check if script already exists
      let scriptId = filename.replace(/[^a-zA-Z0-9]/g, '') + "Script";
      if (document.getElementById(scriptId)) {
        return Promise.resolve();
      }
      
      return new Promise(function(resolve, reject) {
        let script = document.createElement("script");
        if (options.defer) {
          script.setAttribute("defer", "defer");
        } else {
          script.setAttribute("type", "module");
        }
        script.setAttribute("id", scriptId);
        script.setAttribute(
          "src",
          baseUrl + "/formdesigner/" + filename + "?v=" + Date.now() + ""
        );

        script.onload = () => resolve(script);
        script.onerror = () =>
          reject(new Error(`Script load error for ${filename}`));

        document.head.append(script);
      });
    }
  },
  created() {
    let baseUrl = "";
    let runtimePromise = this.loadScript("runtime.js");
    let polyfillsPromise = this.loadScript("polyfills.js");
    let scriptsPromise = this.loadScript("scripts.js", { defer: true });
    let mainPromise = this.loadScript("main.js");
    let self = this;
    const refreshToken = () => {
      axios.get(process.env.VUE_APP_CONTEXT_PATH + "/tokenrefresh", { withCredentials: true })
        .then(() => console.log('Token has been refreshed'))
        .catch((error) => console.error('Cannot aquire token due to an error', error))
    }
    if (constants.TOKEN_REFRESH_INTERVAL) {
      refreshToken();
      this.interval = setInterval(refreshToken, constants.TOKEN_REFRESH_INTERVAL * 60 * 1000);
    }
    this.designerInfo = Promise.all([runtimePromise, polyfillsPromise, scriptsPromise, mainPromise])
      .then(() => {
        return self.setDesignerInfo();
      })
      .catch(() => {
        EventBus.$emit("error-notification", {
          msg: "Error while loading form designer scripts"
        });
      });

    let link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = baseUrl + "/formdesigner/styles.css";
    link.id = "fdStyle";
    document.head.appendChild(link);
  },
  mounted() {
    let self = this;
    let url = self.isFormTemplate
      ? `/templates/form-template/${self.templateId}/form-designer`
      : `/applications/${self.applicationId}/appforms/${self.formId}/form-designer`;
    ApplicationFormAPI.getFormDesignerDetails(url)
      .then(result => {
        self.applicationForm = result.applicationForm;
        self.baseHelpUrl = result.baseHelpUrl;
        self.timeout = result.timeout;
        if (
          self.applicationForm.designerJson ||
          self.applicationForm.templateData
        ) {
          self.loadForm(
            self.applicationForm.designerJson
              ? self.applicationForm.designerJson
              : self.applicationForm.templateData,
            false
          );
        } else {
          if(constantMessages.MESSAGES["application.designer.empty"]) {
            window.popToast(
              constantMessages.MESSAGES["application.designer.empty"],
              "danger",
              "white",
              "error"
            );
          }
        }
        EventBus.$emit("update-pageTitle", "ABPM Form Designer");
      })
      .finally(() => {
        self.fetchCall = true;
      });
    window.getAutoSaveDataForUser();
  },
  beforeRouteLeave(to, from, next) {
    $("#runtimeScript").remove();
    $("#polyfillsScript").remove();
    $("#mainScript").remove();
    $("#scriptsScript").remove();
    $("#fdStyle").remove();
    next();
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    window.location.reload(true);  
  }
};
</script>

<style scoped>
.form-designer-component {
  @import "/formdesigner/css/commonStyles.css";
}
 
</style>

<style scoped>
.toast-close {
    padding: 0 0 0 var(--spacing-05, 1rem);
    opacity: 1;
    font-size: 18px;
    line-height: 1;
    align-content:center ;
    color: #ffffff !important;
    position: absolute !important;
}

.btn-delete-col .control-loading
{
    display: block !important;
    align-items: center;
    justify-content: center;
}

.mfc-textarea-wrapper textarea[readonly] {
    background-color: #fff;
}
</style>
